import { gameSignals } from '@/bridge/gameSignals';
import { uiCommandBus } from '@/bridge/uiCommandBus';
import { t } from '@/i18n';

/**
 * Plan #9 §4.2 — persistent top banner shown only during a practice PLAY round.
 * role=status + aria-live=polite announces the "does not count" state without
 * stealing focus. The Back-to-result button emits practice:exit on the reverse
 * command channel (uiCommandBus); it sets pointer-events:auto because the #ui
 * root is pointer-events:none (main.tsx).
 */
export function PracticeBanner() {
  const scene = gameSignals.currentScene.value;
  const mode = gameSignals.gameMode.value;
  if (scene !== 'PLAY' || mode !== 'practice') return null;

  return (
    <div
      role="status"
      aria-live="polite"
      class="fixed inset-x-0 top-[calc(env(safe-area-inset-top)+44px)] z-40 pointer-events-none flex items-center justify-between gap-2 px-3 py-2 bg-bg/90 border-b border-foil/40"
    >
      <span class="font-mono text-[11px] uppercase tracking-[0.15em] text-foil">
        {t('practice.bannerActive')}
      </span>
      <button
        type="button"
        class="pointer-events-auto shrink-0 px-3 py-1.5 rounded-md bg-white/10 text-text-2 font-mono text-[10px] uppercase tracking-[0.15em] hover:bg-white/20 active:scale-95 transition-all"
        onClick={() => uiCommandBus.emit({ type: 'practice:exit' })}
      >
        {t('practice.backToResult')}
      </button>
    </div>
  );
}
